// extracted by mini-css-extract-plugin
export default {"noAssignment":"styles_noAssignment__TLA3v","entityHeader":"styles_entityHeader__1n8Lk","divider":"styles_divider__Vt74p"};